export function createStableFeedRowKeys(tempPkStringForRealPk) {
  const keys = new Map();
  return entity => {
    const ownKey = `${entity.entityType}-${entity.pkString}`;
    if (keys.has(ownKey)) {
      return keys.get(ownKey);
    }
    const tempPkString = tempPkStringForRealPk(entity.entityType, entity.entityPk);
    const stableKey = tempPkString ? `${entity.entityType}-${tempPkString}` : ownKey;
    keys.set(ownKey, stableKey);
    return stableKey;
  };
}
